import AxiosBase from "@/assets/js/axios-base";
import Axios from "@/assets/js/axios";

let axiosBase = new AxiosBase();
let $axios = Axios.http;

const state = {
  bjiCustomerList: []
};

const getters = {
  allBjiCustomer: state => {
    return state.bjiCustomerList;
  }
};

const actions = {
  fetchAll({ commit, state }) {
    $axios.get(axiosBase.getUrls().getAllBjiCustomer).then(value => {
      commit("writeAllData", value.data);
    });
  }
};

const mutations = {
  writeAllData(state, data) {
    state.bjiCustomerList = data.data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
